import { useRecoilValue } from 'recoil'
import enumsAtom from '@/pages/MDM/atoms/enums.atom.ts'
import { IEnum } from '@/pages/MDM/mdm.types.ts'

const usePrimitives = (): IEnum[] => {
  const state = useRecoilValue(enumsAtom)

  return state.items
}

export default usePrimitives
